export const FIELD_LABELS = {
    moveInDate: "Move-in Date",
    animals: "Number of Animals",
    dog: "Dog",
    dogCount: "Number of Dogs",
    cat: "Cat",
    catCount: "Number of Cats",
    other: "Other Animal",
    otherCount: "Number of Other Animals",
    otherDescription: "Other Animal Description",
    esaCount: "ESA/Service Animals",
    rentSource: "Source of Income",
    takeHomeIncome: "Take-Home Monthly Income",
    bankruptcy: "Bankruptcy/Evictions",
    creditHistory: "Credit History",
    judgment: "Judgment",
    referralSource: "Referral Source",
    additionalNotes: "Additional Notes"
  };